<template>
  <VEmojiPicker @select="addEmoji"
                v-if="$store.getters['global/isEmojiPickerShown'] "
                :labelSearch="$t('room.pick_your_emoji')" />
</template>

<script>
import VEmojiPicker from 'v-emoji-picker'
// import packData from 'v-emoji-picker/data/emojis.json'

export default {
  name: 'Emoji',
  components: {
    VEmojiPicker
  },
  // data: () => ({
  //   pack: packData.data
  // }),
  props: {
    addEmoji: {
      type: Function,
      required: true
    }
  }
}
</script>
